import React from 'react';
import { FormStateBasic } from 'informed';

import { API_SUCCESS } from '@nw/api-constants';
import { LoadingWrapperWithFailure } from '@nw/shared/ui';
import { IDLE, LOADING, SUCCESS } from '@nw/shared/utils';

import {
  PublicFormMachineSendType,
  PublicFormMachineStateType
} from '../../../form/machines/PublicFormsMachine/types';
import { PublicRegistrationForm } from '../../../shared/components/PublicRegistrationForm';
import { defaultCustomFormClassNames } from '../../../shared/constants/FormConstant';
import StepConfig from '../../../shared/stores/models/StepConfig';
import { CustomClassNamesInterface } from '../../../shared/types/MiscellaneousTypes';

import FormExtraHeaderUI from '../../components/FormExtraHeaderUI';
import { UsePublicMachineReturnType } from '../../hooks/usePublicFormsMachine';
import {
  PublicProductFormMachineSendType,
  PublicProductFormMachineStateType
} from '../../machines/PublicFormsMachine/types';

interface Props {
  productCode: string;
  publicFormsMachineState: PublicProductFormMachineStateType;
  publicFormsMachineSend: PublicProductFormMachineSendType;
  renderCustomSuccessPage?: (
    formValues: FormStateBasic['values'],
    publicFormMachineState: PublicFormMachineStateType,
    publicFormMachineSend: PublicFormMachineSendType
  ) => React.ReactElement;
  status: UsePublicMachineReturnType['status'];
  errors: UsePublicMachineReturnType['errors'];
  customClassNames?: CustomClassNamesInterface;
}

class PublicProductFormRegistrationRoute extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  renderPublicRegistrationForm = (): React.ReactElement | null => {
    const {
      publicFormsMachineState,
      publicFormsMachineSend,
      renderCustomSuccessPage,
      customClassNames = defaultCustomFormClassNames
    } = this.props;

    const { productInfo } = publicFormsMachineState.context;
    return (
      productInfo && (
        <PublicRegistrationForm
          publicFormMachineState={publicFormsMachineState}
          publicFormMachineSend={publicFormsMachineSend}
          formConfig={productInfo}
          renderCustomSuccessPage={renderCustomSuccessPage}
          customClassNames={customClassNames}
          customHeader={(eachFormStep: StepConfig) => {
            return <FormExtraHeaderUI eachFormStep={eachFormStep} />;
          }}
        />
      )
    );
  };

  getAPIStatus = (status: UsePublicMachineReturnType['status']) => {
    if (status.getInitialConfigStatus === SUCCESS) {
      return status.getInitialConfigStatus;
    } else if (
      status.getReferralCodesStatus === SUCCESS &&
      status.getProfileDetailsStatus === SUCCESS
    ) {
      return API_SUCCESS;
    } else if (
      status.getReferralCodesStatus === LOADING ||
      status.getProfileDetailsStatus === LOADING ||
      status.getReferralCodesStatus === IDLE ||
      status.getProfileDetailsStatus === IDLE
    ) {
      return LOADING;
    }
    return status.getInitialConfigStatus;
  };

  getAPIError = (
    errors: UsePublicMachineReturnType['errors'],
    status: UsePublicMachineReturnType['status']
  ) => {
    if (
      status.getInitialConfigStatus !== SUCCESS &&
      errors.getProfileDetailsError
    ) {
      return errors.getProfileDetailsError;
    } else if (
      status.getInitialConfigStatus !== SUCCESS &&
      errors.getReferralCodesError
    ) {
      return errors.getReferralCodesError;
    }
    return errors.getInitialConfigError;
  };

  override render() {
    const { status, errors } = this.props;
    return (
      <LoadingWrapperWithFailure
        apiStatus={this.getAPIStatus(status)}
        renderSuccessUI={this.renderPublicRegistrationForm}
        onRetry={() => {
          window.location.reload();
        }}
        apiError={this.getAPIError(errors, status)}
      />
    );
  }
}

export { PublicProductFormRegistrationRoute };
